"use client";
import { useState, MouseEvent } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { signIn, signOut, useSession } from "next-auth/react";
import { useTranslation } from "@/app/i18n/client";
import profile from "@/assets/images/icons/profile.svg";
import { InlineDiv } from "@/common/divs";

export const ProfileButton = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { data: session } = useSession();
  const { push } = useRouter();

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { t } = useTranslation();

  return (
    <div style={{ height: "50px" }}>
      <button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <InlineDiv
          onClick={() => handleClick}
          style={{ cursor: "pointer", marginRight: "5px" }}
        >
          <Image src={profile.src} alt="profile" width={48} height={48} />
        </InlineDiv>
      </button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          className="customMenuItem"
          onClick={() => {
            push("/profile/edit");
          }}
        >
          {t("sidebar.my_profile")}
        </MenuItem>
        <MenuItem
          className="customMenuItem"
          onClick={() => {
            push("/profile/booking");
          }}
        >
          {t("reservations.title")}
        </MenuItem>
        <MenuItem
          className="customMenuItem"
          onClick={() => {
            push("/profile/payment-methods");
          }}
        >
          {t("sidebar.payment_methods")}
        </MenuItem>
        <MenuItem
          className="customMenuItem"
          onClick={() => {
            push("/profile/favorites");
          }}
        >
          {t("sidebar.my_favorites")}
        </MenuItem>
        <MenuItem
          className="customMenuItem"
          onClick={() => {
            push("/profile/rewards");
          }}
        >
          {t("sidebar.rewards")}
        </MenuItem>

        {session?.user ?
          <MenuItem
            className="customMenuItem"
            onClick={() =>
              signOut({
                callbackUrl: "/login",
                redirect: true,
              })
            }
          >
            {t("alerts.logout.title")}
          </MenuItem>
        : <MenuItem className="customMenuItem" onClick={() => signIn()}>
            {t("first_entry.login")}
          </MenuItem>
        }
      </Menu>
    </div>
  );
};

export default ProfileButton;
